var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRIconEmpower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "R_Icon_Empower") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_Empower_v2-0",
    transform: "translate(-20, -585)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R_Icon_Empower",
    transform: "translate(20, 585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4, 1)",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,12.9951038 L3,17.7178374 C3,17.9537292 3.23076923,18.0716752 3.34615385,17.9537292 L6,16.8922158 L8.65384615,17.9537292 C8.76923077,18.0716752 9,17.9537292 9,17.7178374 L9,13.002985",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C12,6.75 11.25,7.40625 10.96875,8.0625 C10.6875,8.71875 10.6875,9.75 10.21875,10.21875 C9.65625,10.78125 8.71875,10.6875 8.0625,10.96875 C7.40625,11.25 6.75,12 6,12 C5.25,12 4.59375,11.25 3.9375,10.96875 C3.28125,10.6875 2.25,10.6875 1.78125,10.21875 C1.21875,9.65625 1.3125,8.71875 1.03125,8.0625 C0.75,7.40625 0,6.75 0,6 C0,5.25 0.75,4.59375 1.03125,3.9375 C1.3125,3.28125 1.3125,2.25 1.78125,1.78125 C2.34375,1.21875 3.28125,1.3125 3.9375,1.03125 C4.59375,0.75 5.25,0 6,0 C6.75,0 7.40625,0.75 8.0625,1.03125 C8.71875,1.3125 9.75,1.3125 10.21875,1.78125 C10.78125,2.34375 10.6875,3.28125 10.96875,3.9375 C11.34375,4.59375 12,5.15625 12,6 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.53640461,10 L8,10 L8,4 L9.85448172,4 C11.1364046,4 12,4.70628496 12,5.96593431 L12,6.18720505 C12,7.25108604 11.3181773,7.87233178 10.3272909,8.00846954 L11.9818728,10 L11.3363045,10 L9.78177266,8.09360253 L8.53640461,8.09360253 L8.53640461,10 Z M9.80911367,7.60849455 C10.7635453,7.60849455 11.4635954,7.14888896 11.4635954,6.18720505 L11.4635954,5.94896397 C11.4635954,4.93608776 10.7727591,4.49354627 9.80911367,4.49354627 L8.53640461,4.49354627 L8.53640461,7.60849455 L9.80911367,7.60849455 Z",
    id: "R",
    fill: "#000000"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIconEmpower);
export default __webpack_public_path__ + "static/media/R_Icon_Empower.8691f9354d8f2159453adf2d888aa014.svg";
export { ForwardRef as ReactComponent };